var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "logo" }),
    _vm._v(" "),
    _c("div", { staticClass: "skinny-content" }, [
      _c("p"),
      _c("h2", {
        domProps: { textContent: _vm._s(_vm.t("register.email_exp1")) },
      }),
      _vm._v(" "),
      _c("p", {
        domProps: { innerHTML: _vm._s(_vm.t("register.email_exp2")) },
      }),
      _vm._v(" "),
      _c("ul", [
        _c("li", {
          domProps: { textContent: _vm._s(_vm.t("register.email_exp3")) },
        }),
        _vm._v(" "),
        _c("li", {
          domProps: { textContent: _vm._s(_vm.t("register.email_exp4")) },
        }),
      ]),
      _vm._v(" "),
      _c("p"),
      _c("h3", {
        domProps: { textContent: _vm._s(_vm.t("register.email_exp5")) },
      }),
      _vm._v(" "),
      _c("p", {
        domProps: { textContent: _vm._s(_vm.t("register.email_exp6")) },
      }),
      _vm._v(" "),
      _c("p", {
        domProps: { textContent: _vm._s(_vm.t("register.email_exp7")) },
      }),
      _vm._v(" "),
      _c("ul", [
        _c("li", {
          domProps: { textContent: _vm._s(_vm.t("register.email_exp8")) },
        }),
        _vm._v(" "),
        _c("li", {
          domProps: { textContent: _vm._s(_vm.t("register.email_exp9")) },
        }),
        _vm._v(" "),
        _c("li", {
          domProps: { textContent: _vm._s(_vm.t("register.email_exp10")) },
        }),
      ]),
      _vm._v(" "),
      _c("p", {
        domProps: { textContent: _vm._s(_vm.t("register.email_exp11")) },
      }),
      _vm._v(" "),
      _c("ul", [
        _c("li", {
          domProps: { textContent: _vm._s(_vm.t("register.email_exp12")) },
        }),
        _vm._v(" "),
        _c("li", {
          domProps: { textContent: _vm._s(_vm.t("register.email_exp13")) },
        }),
        _vm._v(" "),
        _c("li", {
          domProps: { textContent: _vm._s(_vm.t("register.email_exp14")) },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }